import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import SectionHeader from "@/components/SectionHeader";
import api from "@/lib/api";

const InterviewsListPage = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { (async () => setItems(await api.interviews()))(); }, []);

  return (
    <div data-testid="interviews-list-page">
      <section className="pt-16 md:pt-24 pb-10 max-w-[1440px] mx-auto px-5 md:px-10">
        <SectionHeader
          overline="Interviews"
          title="Unhurried conversations with global leaders."
          lede="Long-form interviews with founders, chief executives and operators — each reserved for a subject worthy of the space."
        />
      </section>

      <section className="max-w-[1440px] mx-auto px-5 md:px-10 pb-24 md:pb-32">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8" data-testid="interviews-grid">
          {items.map((it, i) => (
            <motion.div
              key={it.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: (i % 4) * 0.06 }}
              className="editorial-card overflow-hidden"
              data-testid={`interview-card-${it.slug}`}
            >
              <Link to={`/interviews/${it.slug}`} className="block group">
                <div className="relative aspect-[4/5] overflow-hidden bg-cream">
                  <img src={it.image} alt="" loading="lazy" className="card-image absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700" />
                  <div className="absolute top-3 left-3 px-2 py-1 bg-paper/90 backdrop-blur-sm overline overline-muted">{String(i+1).padStart(2,"0")}</div>
                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-ink/90 via-ink/40 to-transparent p-4">
                    <div className="text-[10px] font-mono-editorial uppercase tracking-[0.24em] text-paper/90">{it.country}</div>
                    <div className="mt-2 font-display text-paper text-xl leading-tight">{it.name}</div>
                    <div className="text-paper/70 text-xs mt-1">{it.position} · {it.company}</div>
                    <div className="mt-3 inline-flex items-center gap-1 text-paper text-[11px] font-mono-editorial uppercase tracking-[0.22em]">Read <ArrowRight size={12} /></div>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default InterviewsListPage;
